import Edit from './Edit';
import List from './List';
export { Edit, List };



//////////////////
// WEBPACK FOOTER
// ./src/app/common/file-category/index.ts
// module id = 1271
// module chunks = 0